<script setup lang="ts">
import { onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    v-for="pasta in props.compromisso.data"
    :key="`${pasta.gcpj}`"
    :column="3"
    :label-style="{ width: '15%' }"
    style="margin-top: 24px"
    :title="`Pasta: ${pasta.gcpj}`"
    bordered
  >
    <a-descriptions-item
      v-if="pasta.solics.length > 0"
      label="Solics"
      :span="3"
    >
      <a-descriptions
        v-for="(solic, idx) in pasta.solics"
        :key="`${solic.carteira}-${solic.contrato}`"
        :column="3"
        :label-style="{ width: '15%' }"
        bordered
        :style="{ marginTop: idx === 0 ? '0' : '24px' }"
      >
        <a-descriptions-item label="Agência" :span="3">
          {{ solic.agencia }}
        </a-descriptions-item>
        <a-descriptions-item label="Conta" :span="3">
          {{ solic.conta }}
        </a-descriptions-item>
        <a-descriptions-item label="Carteira" :span="3">
          {{ solic.carteira }}
        </a-descriptions-item>
        <a-descriptions-item label="Contrato" :span="3">
          {{ solic.contrato }}
        </a-descriptions-item>
      </a-descriptions>
    </a-descriptions-item>
    <a-descriptions-item label="Resultado" :span="3">
      {{ pasta.resultado }}
    </a-descriptions-item>
  </a-descriptions>
</template>
